export const APP_CONSTANTS = {
  DEFAULT_COUNTRY_CODE: '+44',
} as const;

export const DEFAULT_COUNTRY_CODE = APP_CONSTANTS.DEFAULT_COUNTRY_CODE;
